import { render, staticRenderFns } from "./SimpleFacturaButton.vue?vue&type=template&id=051cc6fc&"
import script from "./SimpleFacturaButton.vue?vue&type=script&lang=js&"
export * from "./SimpleFacturaButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports